// LazyImage.jsx
import React, { useState, useEffect, useRef } from 'react';

const LazyImage = ({ src, alt = '', className = '', placeholder = '/loadingImg.gif' }) => {
    const [isVisible, setIsVisible] = useState(false);
    const imgRef = useRef();

    useEffect(() => {
        let observer;

        if (imgRef.current) {
            observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            setIsVisible(true);
                            observer.unobserve(entry.target);
                        }
                    });
                },
                {
                    rootMargin: '100px', // preload a bit before fully visible
                }
            );
            observer.observe(imgRef.current);
        }

        return () => {
            if (observer && observer.unobserve) {
                observer.unobserve(imgRef.current);
            }
        };
    }, []);

    return (
        <img
            ref={imgRef}
            src={isVisible ? src : placeholder}
            alt={alt}
            className={className}
            style={{ transition: 'opacity 0.3s ease-in-out', opacity: isVisible ? 1 : 0.5 }}
        />
    );
};

export default LazyImage;
